import { useEffect, useRef } from 'react';
import { systemAlert } from 'shared/src/component';
import { useInstanceId } from 'shared/src/hooks';
import { bridge } from 'shared/src/utils';
import { useGoodsBasic } from '../queries/useGoodsBasic';

// STOP_SALE 상품은 진입 즉시 안내 후 이전 화면으로 복귀시킨다.
// SOLD_OUT 등 다른 sale_type은 현행 유지.
export const useStopSaleGuard = () => {
  const { data: basic } = useGoodsBasic();
  const instanceId = useInstanceId();
  const hasAlertedRef = useRef(false);

  const isStopSale = basic?.sale_type === 'STOP_SALE';

  useEffect(() => {
    if (!isStopSale || hasAlertedRef.current) return;
    hasAlertedRef.current = true;

    systemAlert('판매 중인 상품이 아닙니다', undefined, [
      { text: '확인', onPress: () => bridge.closeInstance({ instanceId }) },
    ]);
  }, [isStopSale, instanceId]);
};
